<template>
  <div>
    <v-btn small outlined color="warning" @click="downloadCodes">Download Recovery Codes</v-btn>

    <div class="recovery-code-block">
      <div v-for="(code, index) in recoveryCodes"
           v-bind:key="index">
        {{ code }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecoveryCodeView",
  props: {
    recoveryCodes: Array
  },
  methods: {
    downloadCodes() {
      let filename = 'dc-client-codes.txt';

      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.recoveryCodes.join('\n')));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();
      document.body.removeChild(element);

      this.$emit('recoveryStored');
    },
  }
}
</script>

<style lang="scss" scoped>
.recovery-code-block {
  border: 1px solid #ccc;
  background-color: #eee;
  padding: 8px 15px;
  line-height: 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  margin-top: 15px;
}
</style>
